import { render, staticRenderFns } from "./office-profiles-card.vue?vue&type=template&id=007d2b3c&scoped=true&lang=pug"
import script from "./office-profiles-card.vue?vue&type=script&lang=ts"
export * from "./office-profiles-card.vue?vue&type=script&lang=ts"
import style0 from "./office-profiles-card.vue?vue&type=style&index=0&id=007d2b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d2b3c",
  null
  
)

export default component.exports